var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowToLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43149 6.99991L10.4419 0.989502L11.8561 2.40372L7.25992 6.99991L11.8561 11.5961L10.4419 13.0103L4.43149 6.99991Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1438 0.999908H0.143799V12.9999H2.1438V0.999908Z",
    fill: "#747474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDMxNDkgNi45OTk5MUwxMC40NDE5IDAuOTg5NTAyTDExLjg1NjEgMi40MDM3Mkw3LjI1OTkyIDYuOTk5OTFMMTEuODU2MSAxMS41OTYxTDEwLjQ0MTkgMTMuMDEwM0w0LjQzMTQ5IDYuOTk5OTFaIiBmaWxsPSIjNzQ3NDc0Ii8+CjxwYXRoIGQ9Ik0yLjE0MzggMC45OTk5MDhIMC4xNDM3OTlWMTIuOTk5OUgyLjE0MzhWMC45OTk5MDhaIiBmaWxsPSIjNzQ3NDc0Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };